export default __webpack_public_path__ + "static/media/Printer.42e45fe2.svg";